﻿<template>
    <q-dialog ref="dialogRef" class="wider-box" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section class="row items-center">
                <q-markup-table flat>
                    <tr>
                        <td>{{ ts('regId') }}</td>
                        <td>{{ props.crew.regId }}</td>
                    </tr>
                    <tr v-if="props.event.value.wsEventId !== null && props.event.value.wsEventId.length > 0">
                        <td>{{ ts('wsId') }}</td>
                        <td :key="refreshWsId">
                            {{ props.crew.wsId }}
                            <q-btn flat color="secondary" class="inline-edit" icon="edit" :title="ts('editItem')" />
                            <q-popup-edit
                                v-model="props.crew.wsId"
                                :title="ts('wsId')"
                                auto-save
                                v-slot="scope"
                                buttons
                                @save="(val, origVal) => updateMemberWsId(props.crew, val, origVal)"
                            >
                                <q-input
                                    v-model="scope.value"
                                    dense
                                    autofocus
                                    @keyup.enter="scope.set"
                                />
                            </q-popup-edit>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ ts('firstName') }}</td>
                        <td :key="refreshFirstName">
                            {{ props.crew.firstName }}
                            <q-btn
                                flat
                                color="secondary"
                                class="inline-edit"
                                icon="edit"
                                :title="ts('editItem')"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            />
                            <q-popup-edit
                                v-model="props.crew.nonMemberFirstName"
                                :title="ts('firstName')"
                                auto-save
                                v-slot="scope"
                                buttons
                                @save="(val, origVal) => updateMemberFirstName(props.crew, val, origVal)"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            >
                                <q-input
                                    v-model="scope.value"
                                    dense
                                    autofocus
                                    @keyup.enter="scope.set"
                                />
                            </q-popup-edit>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ ts('lastName') }}</td>
                        <td :key="refreshLastName">
                            {{ props.crew.lastName }}
                            <q-btn
                                flat
                                color="secondary"
                                class="inline-edit"
                                icon="edit"
                                :title="ts('editItem')"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            />
                            <q-popup-edit
                                v-model="props.crew.nonMemberLastName"
                                :title="ts('lastName')"
                                auto-save
                                v-slot="scope"
                                buttons
                                @save="(val, origVal) => updateMemberLastName(props.crew, val, origVal)"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            >
                                <q-input
                                    v-model="scope.value"
                                    dense
                                    autofocus
                                    @keyup.enter="scope.set"
                                />
                            </q-popup-edit>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ ts('sex') }}</td>
                        <td :key="refreshSex">
                            {{ ts(props.crew.sex) }}
                            <q-btn
                                flat
                                color="secondary"
                                class="inline-edit"
                                icon="edit"
                                :title="ts('editItem')"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            />
                            <q-popup-edit
                                v-model="props.crew.nonMemberSex"
                                :title="ts('sex')"
                                auto-save
                                v-slot="scope"
                                buttons
                                @save="(val, origVal) => updateMemberSex(props.crew, val, origVal)"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            >
                                <q-select
                                    v-model="scope.value"
                                    dense
                                    autofocus
                                    :options="[{ value: 'male', label: ts('male') }, { value: 'female', label: ts('female') }]"
                                    option-value="value"
                                    option-label="label"
                                    map-options
                                    emit-value
                                    @keyup.enter="scope.set"
                                />
                            </q-popup-edit>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ ts('birthDate') }}</td>
                        <td :key="refreshBirthDate">
                            {{ props.crew.birthDate !== null ? ds(props.crew.birthDate, DateFormat.Short) : '' }}
                            <q-btn
                                flat
                                color="secondary"
                                class="inline-edit"
                                icon="edit"
                                :title="ts('editItem')"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            />
                            <q-popup-edit
                                :model-value="ds(props.crew.nonMemberBirthDate, DateFormat.SystemDate)"
                                :title="ts('birthDate')"
                                auto-save
                                v-slot="scope"
                                buttons
                                @save="(val, origVal) => updateMemberBirthDate(props.crew, val, origVal)"
                                v-if="props.crew.isForeign || props.crew.isPublic"
                            >
                                <q-input type="date" v-model="scope.value" dense autofocus @keyup.enter="scope.set" />
                            </q-popup-edit>
                        </td>
                    </tr>
                    <tr v-if="props.crew.isOneTime">
                        <td>{{ ts('citizenship') }}</td>
                        <td>{{ props.crew.nonMemberCitizenshipCountry?.name }}</td>
                    </tr>
                    <tr v-if="props.crew.isOneTime && props.crew.nonMemberCitizenship === Country.CZ">
                        <td>{{ ts('birthCode') }}</td>
                        <td>{{ props.crew.nonMemberBirthCode }}</td>
                    </tr>
                    <tr v-if="props.crew.isOneTime && props.crew.nonMemberCitizenship !== Country.CZ">
                        <td>{{ ts('addressInCountry') }}</td>
                        <td>{{ props.crew.nonMemberAddress }}</td>
                    </tr>
                    <tr>
                        <td>{{ ts(props.crew.isForeign ? 'country' : 'club') }}</td>
                        <td>{{ props.crew.visibleClub }}</td>
                    </tr>
                    <tr>
                        <td>{{ ts('phone') }}</td>
                        <td :key="refreshPhone">
                            <span v-html="props.crew.phone?.formatPhone()" />
                            <span>
                                <q-btn
                                    flat
                                    color="secondary"
                                    class="inline-edit q-ml-xs"
                                    icon="edit"
                                    :title="ts('editItem')"
                                    v-if="props.crew.isForeign || props.crew.isPublic"
                                />
                                <q-popup-edit
                                    v-model="props.crew.nonMemberPhone"
                                    :title="ts('phone')"
                                    auto-save
                                    v-slot="scope"
                                    buttons
                                    @save="(val, origVal) => updateMemberPhone(props.crew, val, origVal)"
                                    v-if="props.crew.isForeign || props.crew.isPublic"
                                >
                                    <q-input
                                        v-model="scope.value"
                                        dense
                                        autofocus
                                        @keyup.enter="scope.set"
                                    />
                                </q-popup-edit>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ ts('email') }}</td>
                        <td :key="refreshEmail">
                            <span v-html="props.crew.email?.formatEmail()" />
                            <span>
                                <q-btn
                                    flat
                                    color="secondary"
                                    class="inline-edit q-ml-xs"
                                    icon="edit"
                                    :title="ts('editItem')"
                                    v-if="props.crew.isForeign || props.crew.isPublic"
                                />
                                <q-popup-edit
                                    v-model="props.crew.nonMemberEmail"
                                    :title="ts('phone')"
                                    auto-save
                                    v-slot="scope"
                                    buttons
                                    @save="(val, origVal) => updateMemberEmail(props.crew, val, origVal)"
                                    v-if="props.crew.isForeign || props.crew.isPublic"
                                >
                                    <q-input
                                        v-model="scope.value"
                                        dense
                                        autofocus
                                        @keyup.enter="scope.set"
                                    />
                                </q-popup-edit>
                            </span>
                        </td>
                    </tr>
                </q-markup-table>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="props.close" color="primary" @click="onDialogOK" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import { DateFormat, ds, ts } from '@/plugins/i18nFormat'
import Country from '@model/Country'
import EventCrew from '@model/EventCrew'
import { useRepo } from 'pinia-orm'
import { QSelect, useDialogPluginComponent } from 'quasar'
import { ref } from 'vue'

const refreshWsId = ref(0)
const refreshFirstName = ref(0)
const refreshLastName = ref(0)
const refreshPhone = ref(0)
const refreshEmail = ref(0)
const refreshSex = ref(0)
const refreshBirthDate = ref(0)

interface Props {
    close?: string
    color?: string
    crew: EventCrew
    event: Event
}

const props = withDefaults(defineProps<Props>(), {
    icon: 'info',
    color: 'primary',
    close: () => ts('close'),
})

defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

function updateMemberFirstName(crew, firstName, origFirstName) {
    if (firstName === origFirstName || firstName.trim().length <= 1)
        return

    useRepo(EventCrew).save({ id: crew.id, nonMemberFirstName: firstName })

    refreshFirstName.value++

    props.event.value?.setModified()
}

function updateMemberLastName(crew, lastName, origLastName) {
    if (lastName === origLastName || lastName.trim().length <= 1)
        return

    useRepo(EventCrew).save({ id: crew.id, nonMemberLastName: lastName })

    refreshLastName.value++

    props.event.value?.setModified()
}

function updateMemberPhone(crew, phone, origPhone) {
    if (phone === origPhone)
        return

    useRepo(EventCrew).save({ id: crew.id, nonMemberPhone: phone })

    refreshPhone.value++

    props.event.value?.setModified()
}

function updateMemberEmail(crew, email, origEmail) {
    if (email === origEmail)
        return

    useRepo(EventCrew).save({ id: crew.id, nonMemberEmail: email })

    refreshEmail.value++

    props.event.value?.setModified()
}

function updateMemberSex(crew, sex, origSex) {
    if (sex === origSex)
        return

    useRepo(EventCrew).save({ id: crew.id, nonMemberSex: sex })

    refreshSex.value++

    props.event.value?.setModified()
}

function updateMemberWsId(crew, wsId, origWsId) {
    if (wsId === origWsId)
        return

    useRepo(EventCrew).save({ id: crew.id, wsId: wsId })

    refreshWsId.value++

    props.event.value?.setModified()
}

function updateMemberBirthDate(crew, birthDate, origBirthDate) {
    if (birthDate === origBirthDate)
        return

    const currentYear = new Date().getFullYear()
    const oldestYear = currentYear - 115

    const birthYear = new Date(birthDate)?.getFullYear()

    if (birthYear >= currentYear || birthYear <= oldestYear)
        return

    useRepo(EventCrew).save({ id: crew.id, nonMemberBirthDate: birthDate })

    refreshBirthDate.value++

    props.crew.nonMemberBirthDate = birthDate

    props.event.value?.setModified()
}
</script>

<style scoped lang="sass">
.wider-box .q-dialog-plugin
    width: auto

.inline-edit
    font-size: 0.75em !important
</style>
